import { render, staticRenderFns } from "./ClassesSelectbox.vue?vue&type=template&id=5fe3d39e&"
import script from "./ClassesSelectbox.vue?vue&type=script&lang=js&"
export * from "./ClassesSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports